import React from 'react';
import { T } from '../../utils/theme';

const StandByStep = ({ onStart }) => {
  return (
    <div onClick={onStart} style={{
      width: '100%', height: '100%', background: T.bg,
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      cursor: 'pointer', userSelect: 'none',
    }}>
      <div style={{ textAlign: 'center', padding: 40 }}>
        <div style={{
          width: 100, height: 100, borderRadius: 28, margin: '0 auto 24px',
          background: '#fff', boxShadow: '0 8px 30px rgba(0,0,0,0.08)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
          <img src="/Barbxpro.png" alt="Barbx" style={{ width: 64, height: 64, objectFit: 'contain' }}
            onError={(e) => { e.currentTarget.style.display = 'none'; }} />
        </div>
        <div style={{ fontSize: 32, fontWeight: 700, color: T.label, letterSpacing: '-0.025em' }}>Barbx</div>
        <div style={{ fontSize: 17, color: T.label2, marginTop: 8 }}>Toque para entrar na fila</div>
      </div>

      <div style={{
        position: 'absolute', bottom: 0, left: 0, right: 0,
        padding: '18px 0', textAlign: 'center',
        background: T.accent, color: '#fff',
        fontSize: 17, fontWeight: 600, letterSpacing: '-0.01em',
      }}>Iniciar atendimento</div>
    </div>
  );
};

export default StandByStep;
